import { createContext, useContext } from 'react';
import { FeedbackTrigger } from '../types/Feedback';

interface SessionFeedbackOptions {
  feedbackType: 'EXPERIENCE' | 'CONTENT';
  contentType?: 'QBANK' | 'FLASHCARDS' | 'VIDEOS';
  // When set, this trigger is recorded on the user (`lastFeedbackTrigger`) once
  // the modal actually shows — used by the session-count milestones
  // (SESSIONS_5/20/50, ORA-196) so each milestone prompts at most once.
  feedbackTrigger?: FeedbackTrigger;
}

interface SessionFeedbackContextValue {
  open: (options: SessionFeedbackOptions) => void;
  close: () => void;
}

export const SessionFeedbackContext = createContext<
  SessionFeedbackContextValue | undefined
>(undefined);

export const useSessionFeedback = () => {
  const context = useContext(SessionFeedbackContext);
  if (!context) {
    throw new Error(
      'useSessionFeedback must be used within SessionFeedbackProvider'
    );
  }
  return context;
};

export type { SessionFeedbackOptions };
